import { PIPELINE_SLUGS } from "lib/constants";
import { normalizeHref } from "lib/normalizeHref";

export const isPipelineUrl = (href: string) => {
  const pathName = normalizeHref(href);

  return PIPELINE_SLUGS.some((s) => pathName.includes(s));
};
